import { call, put, takeEvery } from 'redux-saga/effects';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
import { request } from '../../xhr';
function getFakeData() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        const fakeData = require('./fake');
        return fakeData;
    }
    return false;
}
function* handleInitialize(action) {
    const result = yield call(request, {
        method: 'get',
        url: '/user/friends/birthdays',
        params: {
            limit: 50
        }
    }, getFakeData);
    if (result) {
        yield put(requestSuccess(result));
    } else {
        yield put(requestFailure());
    }
}
export default function* BirthdayPopupRootSaga() {
    yield takeEvery(initialize, handleInitialize);
}
